import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";
import Task from "../../model2/task/task";
import {QuickAddItemType} from "../../../app/quick-add/@types";

// const debug = "ExpensesModule"
const debug = false

const REIMBURSEMENT_DEFAULT = true
const APPROVAL_DEFAULT      = true
const TASKS_DEFAULT         = true
const TASKS_VIEW_DEFAULT    = false

export class ExpensesModule extends ModuleProto {

    public tasks            : boolean       // when true - user can submit toward tasks
    public taskView         : boolean       // when true - user can submit toward tasks
    public approvalRequired : boolean
    public reimbursement    : boolean

    constructor(moduleConfig:JSONObject) {
        super(ModuleType.EXPENSES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=",moduleConfig)

        this.name                    = "Expenses"
        this.description             = "The Expenses module in GoodDay simplifies expense tracking and management. Users can easily record and categorize expenses, upload receipts, and track reimbursement status. With customizable settings and reporting options, it streamlines the expense management process, ensuring accurate financial tracking. "
        this.svgIcon                 = "isvg expenses"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Billing & Finance"


        // Settings
        this.approvalRequired        = _.get(moduleConfig,'approvalRequired', APPROVAL_DEFAULT) as boolean
        this.reimbursement           = _.get(moduleConfig,'reimbursement', REIMBURSEMENT_DEFAULT) as boolean
        this.tasks                   = _.get(moduleConfig,'tasks', TASKS_DEFAULT) as boolean
        this.taskView                = _.get(moduleConfig,'taskView', TASKS_VIEW_DEFAULT) as boolean

        this.settingsUrl             = "settings/expenses"
        this.parentSection           = SettingsParentSection.FINANCE

        this.feature                 = Feature.EXPENSES
        this.validateFeature()

        debug && console.log(debug, "_isEnabled", this._isEnabled, "tasks=", this.tasks, "taskView=", this.taskView)
    }


    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)

        const result = super.toJson();

        if (this.tasks !== TASKS_DEFAULT) {
            result.tasks = this.tasks
        }

        if (this.taskView !== TASKS_VIEW_DEFAULT) {
            result.taskView = this.taskView
        }

        if (this.approvalRequired !== APPROVAL_DEFAULT) {
            result.approvalRequired = this.approvalRequired
        }

        if (this.reimbursement !== REIMBURSEMENT_DEFAULT) {
            result.reimbursement = this.reimbursement
        }

        debug && console.log(debug, "    newConfig=", result)

        return result
    }

    // never tested
    newTaskExpense(task:Task) {
        gd.openNew(QuickAddItemType.EXPENSE, {projectId: task.projectId, task: task})
    }

    newProjectExpense(projectId?:ID) {
        gd.openNew(QuickAddItemType.EXPENSE, {projectId: projectId})
    }

    goToSettings() {
        gd.goTo('settings/expenses')
    }

}
